module.exports = __webpack_public_path__ + "img/flip-forward.d80b477a.svg";